import React from "react";
import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useStyles } from "./ComplianceBar.styles";
import { useTranslation } from "react-i18next";

export const ComplianceBarReferences = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.referencesContainer}>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.completeOnTimeIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("rca.compliance.statuses.completed_on_time")}
                </Typography>
            </Box>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.pendingIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("rca.compliance.statuses.pending")}
                </Typography>
            </Box>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.completeLateIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("rca.compliance.statuses.completed_late")}
                </Typography>
            </Box>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.pendingLateIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("rca.compliance.statuses.pending_late")}
                </Typography>
            </Box>
        </Box>
    );
};
